import { render, staticRenderFns } from "./TempDocumentAlert.vue?vue&type=template&id=3e2efe0b&scoped=true"
import script from "./TempDocumentAlert.vue?vue&type=script&lang=js"
export * from "./TempDocumentAlert.vue?vue&type=script&lang=js"
import style0 from "./TempDocumentAlert.vue?vue&type=style&index=0&id=3e2efe0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2efe0b",
  null
  
)

export default component.exports